import { apiWrapper } from 'ccs-ui-components';
import { useState } from 'react';

import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IActiveJourney } from '../../../store/actions/types/sources/GetAllJourneys';
import { journeyListResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';

const useJourneyEventAssociation = () => {
  const [isLoading, setIsLoading] = useState(false);

  async function callJourneyEventAssociation(serviceName: string, serviceVersion: string) {
    setIsLoading(true);
    const resp = await apiWrapper.post<IActiveJourney, { errorMessage: string }>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/journeys/search`,
      {
        service: {
          serviceName,
          version: serviceVersion
        },
      },
      headersInstance()
    );

    const apiResponse = journeyListResponseSchema.validate(resp.responseBody, {
      abortEarly: true
    });

    if (resp.isError || !apiResponse?.value) {
      setIsLoading(false);
      return {
        errorMessage: resp.errorBody?.errorMessage,
        isError: resp.isError,
        statusCode: resp.statusCode
      };
    }
    const journeyAssociationRecords = resp.responseBody;
    setIsLoading(false);

    return {
      journeyAssociationRecords,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }

  const journeyEventAssociation = async (serviceName: string, serviceVersion: string) => callJourneyEventAssociation(serviceName, serviceVersion);

  return { journeyEventAssociation, isLoading };
};

export default useJourneyEventAssociation;
